import { FC } from 'react';

import { CategoryContentProps } from './types';
import { TrackedPhoneNumber } from '@/components/TrackedPhoneNumber';

const Content: FC<CategoryContentProps> = ({ location }) => (
  <>
    <h2>{`CallAPro${location}: Available Now`}</h2>
    <p>
      {`CallAPro${location}: We service${location || ' your city'} and surrounding areas. Our experts provide full service repairs, maintenance and installation of most home appliances. Call `}
      <TrackedPhoneNumber />
      {` for a consultation.`}
    </p>
    <section>
      <h3>Systems Serviced</h3>
      <p>{`Our${location} technicians can take or any of your home appliances including:`}</p>
      <ul>
        <li>Cooktops</li>
        <li>Dishwashers</li>
        <li>Freezers</li>
        <li>Garbage Disposals</li>
        <li>Ice Makers</li>
        <li>Microwaves</li>
        <li>Ovens</li>
        <li>Refrigerators</li>
        <li>Stoves</li>
        <li>Washing Machines</li>
        <li>Dryers</li>
        <li>Many More</li>
      </ul>
      <p>
        {`Call `}
        <TrackedPhoneNumber />
        {` to get a technician to your${location} location`}
      </p>
    </section>
    <section>
      <h3>{`Brands Serviced`}</h3>
      <p>
        {`Below are just some of the most common brands CallAPro${location} technicians serve. Don't worry if you don't see your brand listed, we can service that too. Call `}
        <TrackedPhoneNumber />
        {` to schedule a service.`}
      </p>
      <ul>
        <li>Amana</li>
        <li>Bosch</li>
        <li>Dacor</li>
        <li>Electrolux</li>
        <li>Estate</li>
        <li>Fisher &amp; Paykel</li>
        <li>Frigidaire</li>
        <li>GE Appliances</li>
        <li>GE Monogram</li>
        <li>GE Profile</li>
        <li>General Electric</li>
        <li>Gibson</li>
        <li>Hotpoint</li>
        <li>Jenn-Air</li>
        <li>Kenmore</li>
        <li>KitchenAid</li>
        <li>LG</li>
        <li>Magic Chef</li>
        <li>Marvel</li>
        <li>Maytag</li>
        <li>Miele</li>
        <li>Monogram</li>
        <li>Samsung</li>
        <li>Speed Queen</li>
        <li>Sub-Zero</li>
        <li>Thermador</li>
        <li>Viking</li>
        <li>Whirlpool</li>
        <li>Wolf</li>
        <li>More</li>
      </ul>
    </section>
    <section>
      <h3>Risk-Free Quotes</h3>
      <p>
        Forget about surprise charges or hidden costs. Before work begins, your technician will provide accurate, up-front pricing that outlines the scope of work and parts needed for your project.
      </p>
    </section>
    <section>
      <h3>Fast, Same Day Service</h3>
      <p>
        {`Servicing an appliance should be simple! We know your time is valuable. That's why we offer 24/7 customer support, same day service and flexible appointment times that fit your schedule. Call us on `}
        <TrackedPhoneNumber />
        {`.`}
      </p>
    </section>
    <section>
      <h3>24-Hour Emergency Repairs</h3>
      <p>
        We understand how important it is to get your appliance back up and running quickly. To best serve you, we have technicians available 24-hours, 7 days a week — in${location || ' your area'}.
        Our fully stocked, so we can handle most appliance repair issues immediately.
      </p>
      <p>
        {`CallAPro${location} has technicians in your area! Call today at `}
        <TrackedPhoneNumber />
        {` to schedule service and get a no-obligation quote.`}
      </p>
    </section>
  </>
);

export default Content;
